import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Grid,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import Cancel from "./../../../../assets/icons/close.png";
import SweetAlertModal from "../../../components/SweetAlertModal/SweetAlertModal.js";
import TextAreaComponents from "../../../components/TextAreaComponents/TextAreaComponents.tsx";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import jwtDecode from "jwt-decode";
import LoadingView from "../../../components/LoadingView/LoadingView.js";

function AddKitchenDialog(props) {
  const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false);
  const [kitchenName, setKitchenName] = useState("");
  const [validPhoneNumber, SetvalidPhoneNumber] = useState(true);
  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState();
  const [maxQueued, setMaxQueued] = useState("");
  const [queuedMaxTime, setQueuedMaxTime] = useState("");
  const [defaultSwitch, setDefaultSwitch] = useState(false);
  const [activeSwitch, setActiveSwitch] = useState(false);
  const [printerIpAddress, setPrinterIpAddress] = useState("");
  const [loadingModal, SetloadingModal] = React.useState(false);
  const handleClose = () => {
    setopenConfirmaitonModal(false);
    props.onHandleAddItem(false);
  };

  const handleDefaultSwitchChange = () => {
    setDefaultSwitch(!defaultSwitch);
  };

  const handleActiveSwitchChange = () => {
    setActiveSwitch(!activeSwitch);
  };

  const handleKitchenNameChange = (e) => {
    setKitchenName(e);
  };

  const handleEmailChange = (e) => {
    setEmail(e);
  };

  const handleMaxQueuedChange = (e) => {
    setMaxQueued(e);
  };
  const handlePrinterIpAddress = (e) => {
    setPrinterIpAddress(e);
  };

  const handleQueuedMaxTimeChange = (e) => {
    setQueuedMaxTime(e);
  };

  // Mobile Number validation

  const handleMobileNumberChange = (props) => {
    setMobileNumber(props);
    try {
      var test = props / 1;
      if (isNaN(test)) {
        var empty = "";
        SetvalidPhoneNumber(false);
        setMobileNumber(empty);
      } else {
        SetvalidPhoneNumber(true);
        setMobileNumber(props);
      }
    } catch {
      console.log("Error");
    }
  };

  const apiAddress = process.env.REACT_APP_SECRET;
  const Restauranttoken = JSON.parse(localStorage.getItem("parentrestaurant"));
  const RestauranttokenLocal = JSON.parse(localStorage.getItem("restaurant"));

  const [restaurantDatas, setRestaurantDatas] = React.useState([]);

  const token = localStorage.getItem("gotasteadmintoken");
  const [userId, setUserId] = useState();

  const loadRestaurantName = () => {
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwtDecode(token);

        setUserId(decodedData.UserId);

        // setTokenData(decodedData)
      } catch (error) {}
    }

    axios
      // .get(apiAddress + "/api/api/RestaurantUserMapper/getbyuseridaAndRestaurantId?userId=" + decodedData.UserId+"&restaurantId="+Restauranttoken.id)
      .get(
        apiAddress +
          `/api/RestaurantUserMapper/getbyuseridaAndRestaurantId?userId=${decodedData.UserId}&restaurantId=${Restauranttoken.id}`
      )
      .then((response) => {
        var list = [];
        response.data.map((dt, i) => {
          var obj = {
            id: dt.restaurantId,
            title: dt.restaurantName,
          };
          list.push(obj);
        });
        setRestaurantDatas(list);
      });
  };

  console.log("restaurant API view id: ", restaurantDatas.id);

  useEffect(() => {
    loadRestaurantName();
  }, []);

  const [selectedRestaurantDatas, setSelectedRestaurantDatas] = useState([]);
  const handleRemoveData = (restaurant) => {
    const updatedRestaurants = selectedRestaurantDatas.filter(
      (r) => r.id !== restaurant.id
    );
    setSelectedRestaurantDatas(updatedRestaurants);
  };

  const submit = () => {
    var valid = true;
    if (mobileNumber.length != 10 && mobileNumber.length != 11) {
      valid = false;
      toast.error("Phone number is not valid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

    if (kitchenName == "" || kitchenName == undefined || kitchenName == null) {
      valid = false;
      toast.error("Kitchen name is not valid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (
      selectedRestaurantDatas.title == "" ||
      selectedRestaurantDatas.title == undefined ||
      selectedRestaurantDatas.title == null
    ) {
      valid = false;
      toast.error("Kitchen Restaurant Name is not valid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (maxQueued == "" || maxQueued == undefined || maxQueued == null) {
      valid = false;
      toast.error("Kitchen name is not valid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (
      printerIpAddress == "" ||
      printerIpAddress == undefined ||
      printerIpAddress == null
    ) {
      valid = false;
      toast.error("Printer Ip Address is not valid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (
      queuedMaxTime == "" ||
      queuedMaxTime == undefined ||
      queuedMaxTime == null
    ) {
      valid = false;
      toast.error("Kitchen name is not valid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

    if (email == "" || email == undefined || email == null) {
      valid = false;
      toast.error("Email is not valid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

    if (valid) {
      postData();
    }
  };

  const restaurant = JSON.parse(localStorage.getItem("restaurant"));
  const postData = async () => {
    const apiAddress = process.env.REACT_APP_SECRET;

    try {
      SetloadingModal(true);
      const response = await axios({
        method: "post",
        url: apiAddress + "/api/Kitchen",
        data: {
          id: 0,
          name: kitchenName,
          restaurantId: selectedRestaurantDatas.id,
          restaurantName: selectedRestaurantDatas.title,
          printerIpAddress: printerIpAddress,
          isDefault: defaultSwitch,
          isActive: activeSwitch,
          emailAddress: email,
          mobileNo: mobileNumber,
          maxQueuedSize: maxQueued,
          queuedMaxTime: queuedMaxTime,
        },
      });

      console.log(response);
      SetloadingModal(false);
      toast.success("Successfully saved", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

      window.location.href = "/restaurant-setup";
    } catch (error) {
      console.log(error);

      toast.error(error.message || "An error occurred", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  useEffect(() => {
    const foundItem = restaurantDatas.find((item) => item.id === restaurant.id);
    setSelectedRestaurantDatas(foundItem);
  }, [restaurantDatas]);

    const closeLoadingModal = () => {
    SetloadingModal(false);
  };


  return (
    <div>
      <React.Fragment>
        <Dialog fullWidth={true} open={props.open} maxWidth={"lg"}>
          <LoadingView open={loadingModal} close={closeLoadingModal} />
          <ToastContainer />
          <SweetAlertModal
            headerText={"Do you want to leave without saving?"}
            bodyText={"All changes made will be lost"}
            open={openConfirmaitonModal}
            onyes={handleClose}
            close={() => {
              setopenConfirmaitonModal(false);
            }}
            id={2}
          />
          <Grid container>
            <Grid item xs={6}>
              <DialogTitle>Kitchen Setup</DialogTitle>
            </Grid>
            <Grid item xs={6}>
              <DialogActions>
                <Button onClick={() => setopenConfirmaitonModal(true)}>
                  <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
          <div style={{ padding: "10px" }}>
            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: "1rem" }}>
                  kitchen Name
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextAreaComponents
                  label={"kitchen Name"}
                  id="1"
                  value={handleKitchenNameChange}
                />
              </Grid>
            </Grid>

            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: "1rem" }}>
                  Email Address
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextAreaComponents
                  label={"Email Address"}
                  value={handleEmailChange}
                  onChange={handleEmailChange}
                />
              </Grid>
            </Grid>

            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <div
                  className="d-flex"
                  style={{ paddingTop: "1rem", gap: "10px" }}
                >
                  <Typography>Restaurant</Typography>
                </div>
              </Grid>
              <Grid item xs={10}>
                {selectedRestaurantDatas ? (
                  <Autocomplete
                    defaultValue={selectedRestaurantDatas}
                    id="restaurant-dropdown"
                    options={restaurantDatas}
                    onChange={(event, newInputValue, reason, detail) => {
                      setSelectedRestaurantDatas(newInputValue);
                    }}
                    className="my-3"
                    getOptionLabel={(option) => option?.title}
                    renderInput={(params) => <TextField {...params} />}
                  />
                ) : (
                  ""
                )}
              </Grid>
            </Grid>

            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: "1rem" }}>
                  Mobile Number
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextAreaComponents
                  label={"Mobile Number"}
                  id="3"
                  value={handleMobileNumberChange}
                  onChange={handleMobileNumberChange}
                />
              </Grid>
              <span
                className={`${validPhoneNumber ? "d-none" : ""}`}
                style={{ color: "red" }}
              >
                Phone Number is not valid
              </span>
            </Grid>
            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: "1rem" }}>
                  Printer Ip Address
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextAreaComponents
                  label={"Printer Ip Address"}
                  value={handlePrinterIpAddress}
                  onChange={handlePrinterIpAddress}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: "1rem" }}>
                  Max Queued
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextAreaComponents
                  label={"Max Queued"}
                  value={handleMaxQueuedChange}
                  onChange={handleMaxQueuedChange}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: "1rem" }}>
                  Queued Max Time
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextAreaComponents
                  label={"Queued Max Time"}
                  value={handleQueuedMaxTimeChange}
                  onChange={handleQueuedMaxTimeChange}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: "1rem" }}>Default</Typography>
              </Grid>
              <Grid item xs={9}>
                <Switch
                  checked={defaultSwitch}
                  onChange={handleDefaultSwitchChange}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: "1rem" }}>Active</Typography>
              </Grid>
              <Grid item xs={9}>
                <Switch
                  checked={activeSwitch}
                  onChange={handleActiveSwitchChange}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={10}></Grid>
              <Grid item xs={2}>
                <Button className="AddItemButtons" onClick={submit}>
                  Save
                </Button>
              </Grid>
            </Grid>
          </div>
        </Dialog>
      </React.Fragment>
    </div>
  );
}

export default AddKitchenDialog;
